import * as ActionTypes from '../actions/constants';

const initialState = {
  busy: false,
  selectedGuestIds: [],
};

const recipients = (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.REQUEST_PROJECT_GUEST_IDS: {
      return { ...state, busy: true };
    }
    case ActionTypes.RECEIVE_PROJECT_GUEST_IDS: {
      // console.log(action.payload);
      const { projectGuestIds } = action.payload;
      // const selectedGuestIds = projectGuestIds.reduce((result, guestId) => {
      //   result[guestId] = true; // eslint-disable-line
      //   return result;
      // }, { ...state.selectedGuestIds });
      return { ...state, busy: false, selectedGuestIds: projectGuestIds };
    }
    case ActionTypes.RESET_SELECTED_GUEST_IDS: {
      return initialState;
    }
    default:
      return state;
  }
};

export default recipients;



/** WEBPACK FOOTER **
 ** ./src/cards/reducers/recipients.js
 **/